import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { CopyrightNoticeComponent } from './components/copyright-notice/copyright-notice.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { TermsOfUseComponent } from './components/terms-of-use/terms-of-use.component';
import { Modules } from 'src/app/appCommon/Enums/enum';
import {AccordionModule} from 'primeng/accordion';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { LoginErrorComponent } from './components/login-error/login-error.component';
import { LogOutComponent } from './components/log-out/log-out.component';
import { caseInsensitiveMatcher } from 'src/app/appCommon/Pipes/LowerCaseUrlSerializer';

const routes: Routes = [
  { matcher: caseInsensitiveMatcher(Modules.CopyrightNotice), component: CopyrightNoticeComponent },
  { matcher: caseInsensitiveMatcher(Modules.PrivacyPolicy), component: PrivacyPolicyComponent },
  { matcher: caseInsensitiveMatcher(Modules.TermsOfUse), component: TermsOfUseComponent },
  { matcher: caseInsensitiveMatcher(Modules.ErrorPage), component: ErrorPageComponent },
  { matcher: caseInsensitiveMatcher(Modules.LoginError), component: LoginErrorComponent },
  { matcher: caseInsensitiveMatcher(Modules.LogOut), component: LogOutComponent }



];

@NgModule({
  declarations: [
       CopyrightNoticeComponent,
       PrivacyPolicyComponent,
       TermsOfUseComponent,
       ErrorPageComponent,
       LoginErrorComponent,
       LogOutComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    AccordionModule,

  ]
})
export class StaticPagesModule { }
